import { Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReportControl } from '@xmedical/core';
import { XmedicalUiModule } from '@xmedical/ui';

@Component({
  selector: 'xmed-single-line-text-field-renderer',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    XmedicalUiModule
  ],
  templateUrl: './single-line-text-field-renderer.component.html',
  styleUrl: './single-line-text-field-renderer.component.scss'
})
export class SingleLineTextFieldRendererComponent {
  control = input.required<ReportControl>();

  valueChanged = output<void>();

  onValueChanges(): void {
    this.valueChanged.emit();
  }
}
